module.exports = __webpack_public_path__ + "media/bootstrap-icons/volume-up-115cbb16.svg";